
import { UserModule } from "@/store/modules/user";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Breadcrumb extends Vue {
  @Prop({ required: true, default: {} }) list!: any;
  @Prop({ required: false, default: false }) clear?: Boolean;

  data: any[] = [];

  @Watch("list", { immediate: true, deep: true })
  onChange() {
    this.data = [];
    if (this.clear) {
      this.data = this.list;
    } else {
      // 默认取上一个路由的信息
      console.log(" this.$router.currentRoute", this.$router.currentRoute);

      this.data.push({
        title: this.$router.currentRoute.matched[0].name,
        url: this.$router.currentRoute.matched[0].redirect + "/"
      });
      this.data.push(...this.list);
    }
  }

  toUrl(item: any) {
    if (!item.url) {
      return false;
    }
    this.$router.push(item.url);
  }
}
